/** Big Bad Cough (GSK DeCostanzo) case-specific JSB scripts (events only). */
export function jsbScripts() {
    window.__bigbadcoughJsb = window.__bigbadcoughJsb || {};

    // Ensure gtag stubs exist (loader/configs live in index.js).
    window.dataLayer = window.dataLayer || [];
    window.gtag =
        window.gtag ||
        function gtag() {
            window.dataLayer.push(arguments);
        };

    const slug = window.location.pathname
        .replace(/^\/+|\/+$/g, "")
        .toLowerCase();

    /**
     * Meta Pixel base init.
     * Kept here to avoid touching shared/common code; fires only once per session.
     */
    if (!window.__bigbadcoughJsb.meta_pixel_loaded) {
        window.__bigbadcoughJsb.meta_pixel_loaded = true;

        !(function (f, b, e, v, n, t, s) {
            if (f.fbq) return;
            n = f.fbq = function () {
                n.callMethod
                    ? n.callMethod.apply(n, arguments)
                    : n.queue.push(arguments);
            };
            if (!f._fbq) f._fbq = n;
            n.push = n;
            n.loaded = true;
            n.version = "2.0";
            n.queue = [];
            t = b.createElement(e);
            t.async = true;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
        })(
            window,
            document,
            "script",
            "https://connect.facebook.net/en_US/fbevents.js"
        );

        window.fbq("init", "1253707816887778");
        window.fbq("track", "PageView");
    }

    /**
     * X (Twitter) Universal pixel base init.
     * CSV: twq('config','o7f0u'). Loads uwt.js once per session.
     */
    if (!window.__bigbadcoughJsb.twitter_pixel_loaded) {
        window.__bigbadcoughJsb.twitter_pixel_loaded = true;

        !(function (e, t, n, s, u, a) {
            e.twq ||
                ((s = e.twq =
                    function () {
                        s.exe
                            ? s.exe.apply(s, arguments)
                            : s.queue.push(arguments);
                    }),
                (s.version = "1.1"),
                (s.queue = []),
                (u = t.createElement(n)),
                (u.async = !0),
                (u.src = "https://static.ads-twitter.com/uwt.js"),
                (a = t.getElementsByTagName(n)[0]),
                a.parentNode.insertBefore(u, a));
        })(window, document, "script");

        window.twq("config", "o7f0u");
    }

    /**
     * Google Ads - Page Load conversion for form pages.
     * CSV: send_to 'AW-10839088199/S-HVCOTLw5ADEMe4vbAo'
     */
    const pageLoadConversionSlugs = new Set(["submit-claim"]);
    if (pageLoadConversionSlugs.has(slug)) {
        const firedKey = `google_page_load_${slug}`;
        if (!window.__bigbadcoughJsb[firedKey]) {
            window.__bigbadcoughJsb[firedKey] = true;
            window.gtag("event", "conversion", {
                send_to: "AW-10839088199/S-HVCOTLw5ADEMe4vbAo",
            });
        }
    }

    /**
     * X (Twitter) Landing Page View - fires once per slug per session
     * across all routes. CSV: twq('event','tw-o7f0u-rc36u',{}).
     */
    if (typeof window.twq === "function") {
        const twitterPageViewKey = `twitter_page_view_${slug || "home"}`;
        if (!window.__bigbadcoughJsb[twitterPageViewKey]) {
            window.__bigbadcoughJsb[twitterPageViewKey] = true;
            window.twq("event", "tw-o7f0u-rc36u", {});
        }
    }

    /**
     * Click-based conversion hooks (matches vendor instructions).
     * - Google: gtag_report_conversion() for Submit Claim
     * - Meta: fbq('track','Lead') on claim submit
     */
    if (slug === "submit-claim") {
        if (!window.__bigbadcoughJsb.google_submit_conversion_fn) {
            window.__bigbadcoughJsb.google_submit_conversion_fn = true;
            window.gtag_report_conversion = function (url) {
                const callback = function () {
                    if (typeof url !== "undefined") {
                        window.location = url;
                    }
                };
                window.gtag("event", "conversion", {
                    send_to: "AW-10839088199/-X6MCN7agYsbEMe4vbAo",
                    event_callback: callback,
                });
                return false;
            };
        }

        if (!window.__bigbadcoughJsb.submit_click_listener_loaded) {
            window.__bigbadcoughJsb.submit_click_listener_loaded = true;
            document.addEventListener(
                "click",
                (event) => {
                    const currentSlug = window.location.pathname
                        .replace(/^\/+|\/+$/g, "")
                        .toLowerCase();
                    if (currentSlug !== "submit-claim") return;

                    const submitButton =
                        event.target?.closest?.("#submit-claim");
                    if (!submitButton || submitButton.disabled) return;

                    if (
                        !window.__bigbadcoughJsb
                            .google_submit_conversion_fired
                    ) {
                        window.__bigbadcoughJsb.google_submit_conversion_fired =
                            true;
                        if (
                            typeof window.gtag_report_conversion === "function"
                        ) {
                            window.gtag_report_conversion();
                        } else {
                            window.gtag("event", "conversion", {
                                send_to:
                                    "AW-10839088199/-X6MCN7agYsbEMe4vbAo",
                            });
                        }
                    }

                    if (!window.__bigbadcoughJsb.meta_lead_fired) {
                        window.__bigbadcoughJsb.meta_lead_fired = true;
                        if (typeof window.fbq === "function") {
                            window.fbq("track", "Lead");
                        }
                    }

                    if (
                        !window.__bigbadcoughJsb.twitter_submit_conversion_fired
                    ) {
                        window.__bigbadcoughJsb.twitter_submit_conversion_fired =
                            true;
                        if (typeof window.twq === "function") {
                            window.twq("event", "tw-o7f0u-rc36v", {
                                conversion_id: null,
                            });
                        }
                    }
                },
                true
            );
        }
    }
}
